<div atlas-banner>
  <div atlas-banner-image>
    <mat-icon>
      videocam
    </mat-icon>
  </div>
  <div atlas-banner-content>
    <p class="m-0 mat-body">
      The video camera function is currently being turned off.
    </p>
  </div>
  <div atlas-banner-actions>
    <button
      atlas-button
      color="accent"
      class="text-uppercase me-2"
      (click)="getDismissAction()">
      Dismiss
    </button>
    <button
      atlas-button
      color="accent"
      class="text-uppercase"
      (click)="performAction()">
      Go To Buttons
    </button>
  </div>
</div>